import React from "react";
import SC from "./style";

const Label = ({ label, children }) => {
  return (
    <>
      <SC.Container>
        <SC.Label>{label}</SC.Label>
        <SC.Children>{children}</SC.Children>
      </SC.Container>
    </>
  );
};

export default Label;
